<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <div
      :class="$isMobile ? 'text-h5' : 'text-h4 mt-10'"
      class="mb-2 primary-grey--text font-weight-regular"
      v-html="typedSections.welcome1"
    />
    <div
      :class="$isMobile ? 'text-subtitle-1' : 'text-h5'"
      class="mb-2 primary-grey--text font-weight-regular"
      v-html="typedSections.welcome2"
    />
    <div
      :class="$isMobile ? 'text-body-1 mb-6' : 'text-h5'"
      class="primary-grey--text font-weight-regular"
      v-html="typedSections.welcome3"
    />
    <div
      :class="$isMobile ? 'text-body-2' : 'text-body-1'"
      :style="
        $isMobile
          ? { width: '100%' }
          : { maxWidth: 'min(90vw, 500px)', margin: '0 auto'
          }"
      class="primary-grey--text mb-4"
    >
      <br v-if="!$isMobile">
      <div
        v-for="i in 2"
        :key="'welcome-bullet-' + i"
        class="d-flex align-start text-left mb-6"
        v-html="typedSections['bulletWelcome' + i]"
      />
    </div>

    <div
      v-if="state.showPSA"
      :class="$isMobile ? 'text-body-2' : 'text-body-1'"
      class="primary-grey--text mt-3 psa-content-wrapper text-left"
    >
      <div
        class="mb-3"
        v-html="typedSections.psaIntro1"
      />

      <div
        class="mb-3"
        v-html="typedSections.psaIntro2"
      />

      <div class="pl-8">
        <div
          v-for="i in 4"
          :key="'psa-bullet-' + i"
          class="mb-2 d-flex"
          v-html="typedSections['psaBullet' + i]"
        />
      </div>

      <div
        class="mt-6"
        v-html="typedSections.psaToolsIntro1"
      />
      <div
        class="mt-3 mb-3"
        v-html="typedSections.psaToolsIntro2"
      />

      <div class="pl-8">
        <div
          v-for="i in 4"
          :key="'psa-tool-' + i"
          class="d-flex align-start mb-2"
          v-html="typedSections['psaTool' + i]"
        />
      </div>

      <div
        class="mt-6 mb-2"
        v-html="typedSections.psaTip"
      />

      <div
        class="mb-2"
        v-html="typedSections.psaExample"
      />

      <div
        class="mt-3"
        v-html="typedSections.psaFeedback"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { COLORS } from '@/helpers/colors';
import { buildSinoaContent } from './data/helpers';

export default {
  name: 'SinoaWelcome',

  data() {
    return {
      COLORS,
      state: {
        showPSA: false,
        psaMarkedAsShown: false,
        hasTypewriterRun: false,
      },
      typedSections: {
        welcome1: '',
        welcome2: '',
        welcome3: '',
        bulletWelcome1: '',
        bulletWelcome2: '',
        psaIntro1: '',
        psaIntro2: '',
        psaBullet1: '',
        psaBullet2: '',
        psaBullet3: '',
        psaBullet4: '',
        psaToolsIntro1: '',
        psaToolsIntro2: '',
        psaTool1: '',
        psaTool2: '',
        psaTool3: '',
        psaTool4: '',
        psaTip: '',
        psaExample: '',
        psaFeedback: '',
      },
      currentStreamInterval: null,
      scrollInterval: null,
    };
  },

  computed: {
    ...mapState('user', ['firstName']),
    userName() {
      return this.firstName || 'User';
    },

    allContent() {
      return buildSinoaContent(this.userName, COLORS.grainfoxAIButton, this.$isMobile);
    },
  },

  mounted() {
    this.checkIfPSAShouldShow();
    if (!this.state.showPSA) {
      this.initializeContentWithoutEffect();
    }
  },

  watch: {
    'state.showPSA': {
      handler(newVal) {
        if (newVal && !this.state.hasTypewriterRun) {
          this.$nextTick(() => {
            this.startTypewriterEffect();
          });
        } else if (!newVal) {
          this.clearTypewriter();
          this.initializeContentWithoutEffect();
        }
      },
      immediate: false,
    },
  },

  updated() {
    if (this.state.showPSA && !this.psaMarkedAsShown) {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem('sinoaPSAShownDate', today);
      this.state.psaMarkedAsShown = true;
    }
  },

  beforeDestroy() {
    this.clearTypewriter();
  },

  methods: {
    checkIfPSAShouldShow() {
      const today = new Date().toISOString().split('T')[0];
      const fabClickDate = localStorage.getItem('sinoaFabClickDate');
      const lastPSAShownDate = localStorage.getItem('sinoaPSAShownDate');
      if (fabClickDate === today && lastPSAShownDate !== today) {
        this.state.showPSA = true;
      }
    },

    initializeContentWithoutEffect() {
      Object.keys(this.allContent).forEach((key) => {
        this.typedSections[key] = this.allContent[key];
      });
      this.state.hasTypewriterRun = false;
    },

    startAutoScroll() {
      this.stopAutoScroll();

      this.scrollInterval = setInterval(() => {
        const chatContainer = this.findScrollContainer();
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      }, 50);
    },

    stopAutoScroll() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },

    findScrollContainer() {
      let parent = this.$el?.parentElement;
      while (parent) {
        if (parent.classList?.contains('chat-container')) {
          return parent;
        }
        parent = parent.parentElement;
      }
      return null;
    },

    startTypewriterEffect() {
      this.clearTypewriter();
      this.state.hasTypewriterRun = true;

      Object.keys(this.typedSections).forEach((key) => {
        this.typedSections[key] = '';
      });

      const sections = Object.keys(this.allContent);
      let currentSectionIndex = 0;

      this.startAutoScroll();

      const typeNextSection = () => {
        if (currentSectionIndex >= sections.length) {
          this.$store.commit('chatbot/setTypewriterCompleted', true);
          this.stopAutoScroll();
          return;
        }

        const sectionKey = sections[currentSectionIndex];
        const fullText = this.allContent[sectionKey];
        let currentIndex = 0;

        const streamInterval = setInterval(() => {
          if (currentIndex < fullText.length) {
            const currentText = fullText.substring(0, currentIndex + 1);
            this.typedSections[sectionKey] = currentText;
            currentIndex += 1;
          } else {
            clearInterval(streamInterval);
            currentSectionIndex += 1;
            typeNextSection();
          }
        }, 1);

        this.currentStreamInterval = streamInterval;
      };

      typeNextSection();
    },

    clearTypewriter() {
      if (this.currentStreamInterval) {
        clearInterval(this.currentStreamInterval);
        this.currentStreamInterval = null;
      }
    },
  },
};
</script>

<style scoped>
.psa-content-wrapper {
  max-width: none !important;
  width: 100% !important;
  text-align: left !important;
}

.psa-content-wrapper > div {
  text-align: left !important;
}

@media (min-width: 960px) {
  .psa-content-wrapper {
    max-width: min(100vw, 900px) !important;
  }
}

@media (min-width: 1261px) {
  .psa-content-wrapper {
    max-width: min(100vw, 1080px) !important;
  }
}
</style>
